import React from 'react';
import PropTypes from 'prop-types';

const FullViewComponent = () => {
    return (
        <div>
            Full View Fields
        </div>
    );
};

FullViewComponent.propTypes = {
    component: PropTypes.object
};

export default FullViewComponent;